import React, { createContext, useContext, useState, useEffect } from 'react';

const BypassContext = createContext();

export const useBypass = () => {
  const context = useContext(BypassContext);
  if (!context) {
    throw new Error('useBypass must be used within a BypassProvider');
  }
  return context;
};

export const BypassProvider = ({ children }) => {
  const [bypassEnabled, setBypassEnabled] = useState(false);
  const [isDevelopment, setIsDevelopment] = useState(false);

  // Check if we're in development mode
  useEffect(() => {
    setIsDevelopment(process.env.NODE_ENV === 'development');
  }, []);

  // Load bypass state from localStorage on mount
  useEffect(() => {
    if (isDevelopment) {
      const savedBypass = localStorage.getItem('dev-paywall-bypass');
      if (savedBypass !== null) {
        setBypassEnabled(savedBypass === 'true');
      }
    }
  }, [isDevelopment]);

  const toggleBypass = () => {
    const newBypassState = !bypassEnabled;
    setBypassEnabled(newBypassState);
    localStorage.setItem('dev-paywall-bypass', newBypassState.toString());
    console.log(`🚫 Paywall bypass ${newBypassState ? 'ENABLED' : 'DISABLED'} (local only)`);
    
    // Don't reload page - let components react to state change
  };

  const value = {
    bypassEnabled,
    loading: false, // No loading needed for local state
    isDevelopment,
    toggleBypass
  };

  return (
    <BypassContext.Provider value={value}>
      {children}
    </BypassContext.Provider>
  );
};